import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Form, Button, Table, Modal } from 'react-bootstrap';
import axios from 'axios';
//Components 
import Navbar from '../NavBar/Navbar';
//API 
import { ClientsFetchAPI } from '../../api/Clients';
//Alerts 
import ErrorAlert from '../Alerts/ErrorAlert';
import SuccessAlert from '../Alerts/SuccessAlert';

// Dashboard for managing frequent shopper clients, their points, and transactions
const FrequentShopperConfigDashboard = () => {
    const [config, setConfig] = useState({
        point_value: 0,
        points_per_product: null,
        points_name: '',
        redemption_enabled: false,
        points_per_dollar_redeem: null
    });
    // Get token and user from localStorage
    let token = localStorage.getItem('x-access-token');
    let user = JSON.parse(localStorage.getItem('user'))


    // Load config
    useEffect(() => {
        getFrequentShopperConfig()
    }, []);

    //Function to get the frecuent shopper config
    const getFrequentShopperConfig = async () => {
        try {
            const res = await ClientsFetchAPI.getFrecuentShopperConfig(token, user.business.id);
            setConfig(res.data.data);
        } catch (error) {
            setConfig({
                point_value: 0,
                points_per_product: null,
                points_name: '',
                redemption_enabled: false,
                points_per_dollar_redeem: null
            });
        }
    };

    //Function to manage the frecuent shopper config
    const manageFrecuentShopperConfig = async () => {
        try {
            await ClientsFetchAPI.manageFrecuentShopperConfig(
                user.business.id,
                config.point_value,
                config.points_name,
                config.redemption_enabled,
                config.points_per_dollar_redeem,
                token
            );
            SuccessAlert('Configuración guardada correctamente');
            getFrequentShopperConfig(); // Refresh config after saving
        } catch (error) {
            ErrorAlert('Error al guardar la configuración', error.message);
            setConfig({ point_value: 0, points_per_product: null, points_name: '', redemption_enabled: false, points_per_dollar_redeem: null });
        }
    };

    return (
        <>
            <Navbar titlePage="Config-Frecuent Shopper" route="config/new_frecuent-client" />
            <div className='bg-light pt-4'>
                <div className='container'>

                    {/* Main content starts here */}
                    <main>
                        <h2 className="my-4">Configurar - Cliente frecuente</h2>

                        <Row>
                            <Col md={12}>
                                <Card className="mb-4">
                                    <Card.Body>
                                        <Card.Title>Configuración de Puntos</Card.Title>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Valor del Punto por cada dólar ($) para obtenerlos</Form.Label>
                                            <Form.Control
                                                type="number"
                                                value={config.point_value}
                                                onChange={(e) => setConfig({ ...config, point_value: e.target.value })}
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nombre de los puntos ($)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={config.points_name}
                                                onChange={(e) => setConfig({ ...config, points_name: e.target.value })}
                                            />
                                        </Form.Group>


                                        <hr />

                                        <Card.Title>Configuración de Canje</Card.Title>

                                        <Form.Group className="mb-3">
                                            <Form.Check
                                                type="switch"
                                                label="Habilitar canje de puntos como método de pago"
                                                checked={config.redemption_enabled === 1}
                                                onChange={() =>
                                                    setConfig({
                                                        ...config,
                                                        redemption_enabled: config.redemption_enabled === 1 ? 0 : 1
                                                    })
                                                }
                                            />
                                        </Form.Group>

                                        {config.redemption_enabled === 1 && ( // <-- aquí el fix
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    Cantidad de puntos que son necesarios por cada dólar ($) al momento del pago del cliente
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    value={config.points_per_dollar_redeem || ''}
                                                    onChange={(e) =>
                                                        setConfig({ ...config, points_per_dollar_redeem: e.target.value })
                                                    }
                                                />
                                            </Form.Group>
                                        )}
                                        <Button variant="primary" onClick={manageFrecuentShopperConfig}>Guardar Configuración</Button>
                                    </Card.Body>
                                </Card>
                            </Col>


                        </Row>
                    </main>

                </div>
            </div>




        </>
    );
};

export default FrequentShopperConfigDashboard;
